import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onlinetaxibookingmumbai() {



const cardData = {
  keyword: "Online Taxi Booking Mumbai",
  heading: "Lotus Cab: Online Taxi Booking Mumbai",

  headingDescription:
    "Lotus Cab provides fast, secure, and reliable Online Taxi Booking in Mumbai for city travel, airport transfers, corporate rides, family trips, and outstation journeys. Our easy-to-use booking system allows customers to reserve AC sedans, SUVs, luxury vehicles, and mini buses instantly with transparent pricing. Whether you need a one-way cab, round trip taxi, weekend getaway ride, or same-day booking, we ensure punctual service with professional chauffeurs. All vehicles are well-maintained, sanitized, and GPS-enabled for safe travel. With competitive per-kilometer rates and 24/7 customer support, Lotus Cab guarantees a smooth, convenient, and affordable online cab booking experience in Mumbai.",

  top: "Top Places to Visit in Mumbai with Lotus Cab",

  topPlaces: [
    {
      title: "Gateway of India",
      description:
        "The Gateway of India is Mumbai’s most iconic landmark attracting tourists from across the country. Booking a taxi online makes it easy to avoid parking issues. Our AC cabs ensure comfortable travel even during peak hours. Ideal for family visits and sightseeing tours. Chauffeur-driven service allows relaxed exploration. Lotus Cab provides flexible waiting time options."
    },
    {
      title: "Marine Drive",
      description:
        "Marine Drive is perfect for evening drives and weekend relaxation. Online taxi booking ensures instant availability without delays. AC sedan or SUV options provide comfortable city travel. Ideal for couples and families."
    },
    {
      title: "Siddhivinayak Temple",
      description:
        "One of Mumbai’s most visited temples requiring timely travel. Online cab booking ensures smooth darshan trips. Professional drivers navigate city traffic efficiently."
    },
    {
      title: "Juhu Beach",
      description:
        "Popular beach destination for family and weekend outings. Comfortable AC taxis ensure stress-free travel. Suitable for small groups and family trips."
    },
    {
      title: "Chhatrapati Shivaji Maharaj International Airport",
      description:
        "Airport transfers require punctual service. Online booking guarantees timely pickup and drop. Multiple vehicle options available for luggage comfort."
    },
    {
      title: "Elephanta Caves",
      description:
        "Heritage destination near Mumbai requiring reliable travel coordination. Online cab booking ensures smooth travel planning."
    }
  ],

  services: [
    {
      name: "Online Taxi Mumbai",
      description:
        "Book reliable taxis online in Mumbai for city rides, airport transfers, and outstation travel. Our easy booking system provides instant confirmation and transparent pricing. Choose from sedans, SUVs, and luxury vehicles. Clean and sanitized cars ensure safety. Professional drivers guarantee punctual service. Ideal for daily commuting and weekend trips."
    },
    {
      name: "AC Cab Online Booking Mumbai",
      description:
        "Fully air-conditioned vehicles available for online booking across Mumbai. Comfortable interiors for summer travel. Suitable for family and corporate rides. Transparent per-km rates shared before confirmation. Chauffeur-driven service ensures smooth city navigation."
    },
    {
      name: "Sedan Cab Online Mumbai",
      description:
        "Economical sedan taxis perfect for solo and small family travel. Smooth ride quality and excellent fuel efficiency. Ideal for airport and local transfers. Online booking provides quick confirmation."
    },
    {
      name: "SUV Cab Online Mumbai",
      description:
        "Spacious SUV taxis for group travel and extra luggage needs. Powerful performance and comfortable seating. Suitable for long-distance and outstation travel."
    },
    {
      name: "Luxury Cab Online Mumbai",
      description:
        "Premium luxury vehicles for executive and VIP travel. Ideal for business meetings and special occasions. Professional chauffeurs ensure elegant travel experience."
    },
    {
      name: "Airport Transfer Online Mumbai",
      description:
        "Reliable airport pickup and drop service with real-time tracking. Timely arrival and luggage support included. Suitable for domestic and international transfers."
    },
    {
      name: "Outstation Cab Online Mumbai",
      description:
        "Book long-distance intercity cabs with transparent fare calculation. Flexible one-way and round-trip options available."
    },
    {
      name: "Mini Bus Online Booking Mumbai",
      description:
        "Mini bus options available for group travel, corporate events, and family functions. Comfortable seating and professional drivers included."
    }
  ],

  tableData: [
    ["Online Taxi Mumbai", "Book Cab Online Mumbai"],
    ["AC Cab Online Booking Mumbai", "Sedan Cab Online Mumbai"],
    ["SUV Cab Online Mumbai", "Luxury Cab Online Mumbai"],
    ["Airport Transfer Online Mumbai", "Outstation Cab Online Mumbai"],
    ["Family Trip Cab Online Mumbai", "Corporate Cab Online Mumbai"],
    ["One Way Online Cab Mumbai", "Round Trip Online Cab Mumbai"],
    ["Weekend Trip Cab Online Mumbai", "Mini Bus Online Booking Mumbai"],
    ["Chauffeur Driven Online Cab Mumbai", "Picnic Trip Cab Online Mumbai"],
    ["Same Day Online Cab Mumbai", "Budget Cab Online Mumbai"],
    ["Per Km Rate Online Cab Mumbai", "Best Online Taxi Mumbai"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Instant Online Booking",
      WhyChoosedescription:
        "Quick and secure booking system with immediate confirmation and transparent pricing."
    },
    {
      WhyChooseheading: "Wide Vehicle Selection",
      WhyChoosedescription:
        "Sedans, SUVs, luxury cars, and mini buses available for different travel needs."
    },
    {
      WhyChooseheading: "Transparent Fare Structure",
      WhyChoosedescription:
        "Clear per-kilometer rates with no hidden charges."
    },
    {
      WhyChooseheading: "Professional Chauffeurs",
      WhyChoosedescription:
        "Trained drivers ensuring safe and punctual travel."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription:
        "Round-the-clock service for urgent and late-night travel."
    },
    {
      WhyChooseheading: "Clean & Sanitized Fleet",
      WhyChoosedescription:
        "Vehicles regularly maintained and sanitized."
    },
    {
      WhyChooseheading: "Airport & Outstation Support",
      WhyChoosedescription:
        "Dedicated airport transfers and long-distance travel services."
    },
    {
      WhyChooseheading: "Corporate Billing Support",
      WhyChoosedescription:
        "Invoice support available for business travel bookings."
    }
  ]
};

const faqData = [
  {
    question: "How can I book a taxi online in Mumbai?",
    answer:
      "You can book a taxi online through our website or WhatsApp. Select vehicle type, pickup location, and schedule. Instant confirmation is provided. Transparent pricing is shown before booking confirmation."
  },
  {
    question: "Are airport transfers available online?",
    answer:
      "Yes, airport pickup and drop services are available 24/7. We monitor flight timings for punctual service. Multiple vehicle options are available based on luggage and passenger count."
  },
  {
    question: "Is one-way booking available?",
    answer:
      "Yes, one-way online taxi booking is available for city and outstation travel. Pay only for the distance traveled."
  },
  {
    question: "Are SUVs available for booking?",
    answer:
      "Yes, spacious SUVs are available for family and group travel. Ideal for long-distance journeys."
  },
  {
    question: "Do you provide luxury vehicles?",
    answer:
      "Yes, premium luxury cars are available for executive and VIP travel needs."
  },
  {
    question: "Is pricing transparent?",
    answer:
      "Yes, complete fare details are shared before booking confirmation."
  },
  {
    question: "Is same-day booking possible?",
    answer:
      "Yes, same-day online booking is available depending on vehicle availability."
  },
  {
    question: "Are drivers professional?",
    answer:
      "All drivers are trained, background-verified, and experienced."
  },
  {
    question: "Is customer support available 24/7?",
    answer:
      "Yes, our team is available round-the-clock for assistance."
  },
  {
    question: "Can I book a mini bus online?",
    answer:
      "Yes, mini buses are available for group travel and corporate events."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Mehta",
    feedback:
      "Booked online taxi for airport transfer. Driver arrived on time and vehicle was clean and comfortable. The online booking process was smooth and transparent.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Kulkarni",
    feedback:
      "Used online cab booking for family trip. SUV was spacious and driver was professional. Transparent pricing and good support.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Reliable corporate online taxi booking with proper billing support. Punctual and professional service.",
    rating: 5
  },
  {
    id: 4,
    name: "Mr. Ajay Shah",
    feedback:
      "Quick confirmation and stress-free booking experience. Highly recommended online taxi service in Mumbai.",
    rating: 5
  }
];


































































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Online Taxi Booking Mumbai",
  "image": "https://lotuscab.com/assets/images/online-taxi-mumbai.jpg",
  "description": "Book online taxis in Mumbai with Lotus Cab. Choose from AC, sedan, SUV, luxury cabs, Mini Bus, or chauffeur-driven rides for airport transfers, outstation trips, family trips, corporate travel, one-way or round trips, weekend trips, and same-day bookings. Competitive per km rates.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "299",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/online-taxi-booking-mumbai"
  }
};




  return (
    <div>
      

<Helmet>
  <title>Online Taxi Booking Mumbai | Lotus Cab | Call +91 8767592195</title>
  <meta 
    name="description" 
    content="Book online taxis in Mumbai with Lotus Cab. AC, sedan, SUV, luxury cabs, Mini Bus & chauffeur-driven options for airport transfers, outstation trips, family & corporate travel. One-way, round trips, weekend & same-day trips available. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Online Taxi Mumbai, Book Cab Online Mumbai, AC Cab Online Booking Mumbai, Sedan Cab Online Mumbai, SUV Cab Online Mumbai, Luxury Cab Online Mumbai, Airport Transfer Online Mumbai, Outstation Cab Online Mumbai, Family Trip Cab Online Mumbai, Corporate Cab Online Mumbai, One Way Online Cab Mumbai, Round Trip Online Cab Mumbai, Weekend Trip Cab Online Mumbai, Mini Bus Online Booking Mumbai, Chauffeur Driven Online Cab Mumbai, Picnic Trip Cab Online Mumbai, Same Day Online Cab Mumbai, Budget Cab Online Mumbai, Per Km Rate Online Cab Mumbai, Best Online Taxi Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/65.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onlinetaxibookingmumbai;